import { render, staticRenderFns } from "./DetailGabungKelas.vue?vue&type=template&id=6f22866a&"
import script from "./DetailGabungKelas.vue?vue&type=script&lang=js&"
export * from "./DetailGabungKelas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports